export default __webpack_public_path__ + "static/media/startup-girl.407e3aee.svg";